// firebase-config.ts
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBhsoI8fPKB8XUgEv7UBaJ-vengNODNNIo",
  authDomain: "video-prod.firebaseapp.com",
  projectId: "video-prod",
  storageBucket: "video-prod.firebasestorage.app",
  messagingSenderId: "837573027188",
  appId: "1:837573027188:web:e42cebe0508d54404ff821"
};

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

export { messaging, getToken, onMessage };
